import HttpRequest from '@/utils/axios'
const baseUrl = process.env.NODE_ENV === 'development' ? '/local' : 'https://games-cn-gw.jedi-games.com/gw/games/web/php/json_gateway.php'

const axios = new HttpRequest(baseUrl)
export default axios



// WEBPACK FOOTER //
// ./src/utils/api.request.js